import { formatWeight } from './formatters';

function extractErrorCode(error: any) {
  const code = error?.code ?? error?.data?.code ?? error?.response?.data?.code;
  return code != null ? String(code) : '';
}

function extractErrorData(error: any) {
  return error?.data ?? error?.response?.data?.data ?? error?.response?.data ?? {};
}

export function getPdaErrorMessage(error: any, fallback = '操作失败') {
  const code = extractErrorCode(error);
  const data = extractErrorData(error);

  switch (code) {
    case '400200261001':
      return '这不是员工卡，请重新扫';
    case '400200261002':
      return '卡过期了，找管理员换新卡';
    case '400200264001':
      return '系统里查不到这个料头，问一下派料员';
    case '400200264007':
      return '重量要大于 0 小于 1000kg';
    case '400200264008': {
      const stockWeight = data.current_stock_weight ?? data.stock_weight ?? data.remaining_weight;
      return stockWeight != null
        ? `库存只有 ${formatWeight(stockWeight)}kg,出不了这么多`
        : '库存不足，出不了这么多';
    }
    case '400200264009':
      return '这料头已经出库/报废了,不能再操作';
    case '400200264010':
      return '报废料头不能入库';
    case '400200264011': {
      const locCode = data.loc_code ?? data.current_loc ?? data.current_location;
      return locCode ? `这个料头已经在 ${locCode},不用调` : '这个料头已经在当前库位,不用调';
    }
    case '400200264012':
      return '这个料头还没上架,请先走入库';
    case '400200264013':
      return '长度必须大于 0';
    case '400200264014':
      return '先加入至少一个料头';
    case '400200264015':
      return '待提交里有重复料头，请检查后再提交';
    case '404200268005':
    case 'WhLocNotFound':
      return '库位不存在,检查下是不是扫错或者没导入';
    case '400200268006':
    case 'WhLocDisabled':
      return '这个库位停用了,换个库位';
    case '404200272001':
    case 'WhPreInboundNotFound':
      return '预入库单不存在';
    case '400200272002':
    case 'WhPreInboundBatchNoExists':
      return '入库批次号已存在';
    case '400200272003':
    case 'WhPreInboundLocked':
      return '预入库单已锁定,不能继续录入';
    case '400200272004':
    case 'WhPreInboundPiecesOverflow':
      return '累计支数超过总支数';
    case '400200272005':
    case 'WhPreInboundWeightOverflow':
      return '累计重量超过总重量';
    case '400200272006':
    case 'WhPreInboundFinalizeShort':
      return '详情未拆完,不可关单';
    case '400200272009':
    case 'WhPreInboundSKUNotFound':
      return '原材料 SKU 不存在';
    case '500200272005':
    case 'WhPreInboundAddItemFailed':
      return '添加入库详情失败,稍后重试';
    default:
      return error?.msg || error?.message || fallback;
  }
}
